import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px 20px 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.primary};
  background: ${({ theme }) => theme.colors.background.primary};
  margin-bottom: 8px;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ContractNumber = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.element.primary};

  strong {
    font-weight: 700;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.brand.primary};
  font-size: 13px;
  padding: 0;
`;
